import React from "react";
import { useSelector } from "react-redux";

import { SINGLE_TRIP } from "@/constants";
import {
  CancellationCovers,
  ComparisonTableAreaContentType,
} from "@/schema/quote-page/page.schema";
import { RootState } from "@/store/root-reducer";
import isCruiseImpact from "@/utils/check-cruise-impact-base-on-brand.utils";

import ComparisionTableBlock from "../../quote-comparison-table/comparison-table-block";
import getComparisonTableData from "../../quote-comparison-table/magnolia-data-map-comparison-table";
import { DrawerData } from "../../quote-section/quote-cover/cover-level-selection-card-bottom/cover-level-selection-card-bottom";
import MoreDetails from "../more-details/more-details";

type QuoteComparisonTableProps = {
  selectedTab: string; // Change `any` to the appropriate type
  drawerData: ComparisonTableAreaContentType; // Change `any` to the appropriate type
  isMobileOnly?: boolean;
  supportDrawerData?: DrawerData;
  onSeeMoreDetails?: (index: number) => void;
  setCancellationCoverOpen?: (val: boolean) => void;
  setCancelltionChangeCoverType: (val: string) => void;
  setDynamicCoverLimit: (val: CancellationCovers[] | null) => void;
  detailsRef?: React.RefObject<HTMLDivElement | null>;
};

export default function MobileQuoteComparisonTable({
  selectedTab,
  drawerData,
  isMobileOnly = false,
  onSeeMoreDetails,
  setCancellationCoverOpen,
  setCancelltionChangeCoverType,
  setDynamicCoverLimit,
  detailsRef,
}: Readonly<QuoteComparisonTableProps>) {
  const quoteData = useSelector((state: RootState) => state.quote);
  const { attributes } = quoteData;

  const { tripDetails } = attributes;

  const { comparisonTableAMTRow, comparisonTableSTRow, comparisonTableData } =
    drawerData;

  const compData = getComparisonTableData(
    comparisonTableData,
    tripDetails?.goingOnCruise && isCruiseImpact,
    tripDetails?.policyType
  );

  const columnTitles = compData[0]?.columnTitle ?? {};
  return (
    <div
      className="pt-[7px]"
      data-testid="mobile-quote-comparison-table-test-id"
    >
      <div className="flex flex-col">
        <div className="bg-surface-neutral-option-1 justify-self-center grid mb-spacing-m">
          <ComparisionTableBlock
            setDynamicCoverLimit={setDynamicCoverLimit}
            setCancelltionChangeCoverType={setCancelltionChangeCoverType}
            setCancellationCoverOpen={setCancellationCoverOpen}
            data={
              compData[0]?.comparisonTableRow ??
              (selectedTab === SINGLE_TRIP
                ? comparisonTableSTRow
                : comparisonTableAMTRow)
            }
            isMobileOnly={isMobileOnly}
          />
          <div ref={detailsRef}>
            <MoreDetails
              onClick={(index) => onSeeMoreDetails?.(index)}
              compData={columnTitles}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
